import React from "react";

export const GlobalData = React.createContext();
export const AccountsData = React.createContext();
export const UserData = React.createContext();
export const UserFavoritesNgos = React.createContext();
